export const userInputValidation =(input) => {
  return input.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/=/g, "equal;");
}

export const validateUsername = (username) => {
  /** Blank check*/
  if (username.length <= 1)
    return { valid: false, error: "This field is required." };
  if (username.length < 6)
    return { valid: false, error: "Minimum 6 cheracter required." };
  /** Length check*/
  /** Format- Only characters,digits,. and _ check*/
  let usernameRegEx = /^[a-zA-Z0-9._]*$/;
  if (usernameRegEx.test(username) == false)
    return {
      valid: false,
      error: "Please enter valid username.",
    };

  return { valid: true, error: null };
};
export const validateFirstName = (first_name) => {
  /**Blank check*/
  if (!first_name.length)
    return { valid: false, error: "This field is required." };
  if (first_name.length < 3)
    return { valid: false, error: "Minimum 3 cheracter required." };
  /**Formatting check*/
  let nameRegEx = /^[A-Za-z\s]+$/;
  if (nameRegEx.test(first_name) == false)
    return {
      valid: false,
      error: "Invalid First Name. It can only be characters or space.",
    };
  /** Length*/
  if (first_name.length > 20)
    return {
      valid: false,
      error: "First Name can't be that long. Maximum limit is 20 charatcers",
    };

  return { valid: true, error: null };
};
export const validateLastName = (last_name) => {
  /**Blank check*/
  if (!last_name.length)
    return { valid: false, error: "This field is required." };
  if (last_name.length < 3)
    return { valid: false, error: "Minimum 3 cheracter required." };
  /** Formatting check*/
  let nameRegEx = /^[A-Za-z\s]+$/;
  if (nameRegEx.test(last_name) == false)
    return {
      valid: false,
      error: "Invalid Last Name. It can only be characters or space.",
    };
  /** Length */
  if (last_name.length > 20)
    return {
      valid: false,
      error: "Last Name can't be that long. Maximum limit is 20 charatcers",
    };

  return { valid: true, error: null };
};
export const validatePhone = (phone) => {
  /** Blank check*/

  if (!phone.length) return { valid: false, error: "This field is required." };
  if (!phone.match(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/))
    return { valid: false, error: "Please, enter a valid phone number." };
  //Formatting
  // if (!phone.match( /^[+][(]?[0-9]{1,3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,7}$/gm))
  //     return {valid: false, error: "Please, enter a valid international phone number."};
  return { valid: true, error: null };
};
export const validateEmail = (email) => {
  /** Blank */
  if (!email.length) return { valid: false, error: "This field is required" };
  /** Formatting */
  if (!email.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/))
    return { valid: false, error: "Please, enter a valid email." };

  return { valid: true, error: null };
};
export const validateLoginPassword = (password, password_repeat) => {
  /** Blank */
  if (!password.length)
    return { valid: false, error: "This field is required" };
  if (password.length < 8 || password.length > 20)
    return { valid: false, error: "Password must be between 8-20 characters" };
  /** Length */
  return { valid: true, error: null };
};
export const validatePassword = (password, fieldName) => {
  /** Blank */
  if (!password.length)
    return { valid: false, error: "This field is required" };
  if (password.length && fieldName == "oldPassword") {
    if (password.length < 32) {
      return { valid: true, error: null };
    } else {
      return { valid: true, error: "Password must be less then 32 characters" };
    }
  }
  /** Length */
  if (password.length < 8 || password.length > 20)
    return { valid: false, error: "Password must be between 8-20 characters" };

  /** Formatting */
  let passwordFormat = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,20}$/;
  if (passwordFormat.test(password) == false)
    return {
      valid: false,
      error:
        "Password must contain at least one uppercase letter, one lowercase letter, one number and one special characters",
    };
  return { valid: true, error: null };
};
export const validateRepeatPassword = (password, password_repeat, val, key) => {
  // console.log("key+++++key+++key", key);
  if (!password_repeat.length)
    return { valid: false, error: "This field is required" };
  if (password != password_repeat && key != "change_password") {
    return {
      valid: false,
      error:
        "Password and Confirmation password do not match. Please try again.",
    };
  } else if (password != password_repeat && key == "change_password") {
    return {
      valid: false,
      error:
        "Your New password and Confirmation password do not match. Please try again.",
    };
  }
  return { valid: true, error: null };
};

export const validateRole = role => {
  /**Blank check*/
  if (!role)
    return { valid: false, error: "This field is required." };
  return { valid: true, error: null };
};

export const validateCountryCode = code => {
  if(!code){
    return { valid: false, error: "This field is required." };
  } else {
    return { valid: true, error: null };
  }
}